import React from 'react';
import PropTypes from 'prop-types';

import { CalculationContext } from '../../../../context/CalculationContext';
import NumberInput from '../components/NumberInput';

const InitialParameters = (props) => {
    const calculationContext = React.useContext(CalculationContext);

    const handleApplicationChange = (e) => {
        const currentApplication = props.applications.find(item => item.value.application === e).value;
        const currentCountry = props.countries.find(item => item.value.country === calculationContext.country).value;
        const estimatedEnergyUsageNewBuilding = currentApplication.estimatedEnergyUsageNewBuilding > 0 ? currentApplication.estimatedEnergyUsageNewBuilding : currentCountry.estimatedEnergyUsageNewBuilding;
        const estimatedEnergyUsageExistingBuilding = currentApplication.estimatedEnergyUsageExistingBuilding > 0 ? currentApplication.estimatedEnergyUsageExistingBuilding : currentCountry.estimatedEnergyUsageExistingBuilding;
        const electricityFactor = currentApplication.electricityFactor > 0 ? currentApplication.electricityFactor : calculationContext.initialElectricityFactor;

        calculationContext.setApplication(e);
        calculationContext.setEnergyUsePerSquareMeter(
            calculationContext.newBuilding
                ? estimatedEnergyUsageNewBuilding
                : estimatedEnergyUsageExistingBuilding
        );
        calculationContext.setElectricityFactor(electricityFactor);
    };

    const handleBuildingTypeChange = (e) => {
        const isNewBuilding = e === props.translations.newBuildingLabel;
        const currentApplication = props.applications.find(item => item.value.application === calculationContext.application).value;
        const currentCountry = props.countries.find(item => item.value.country === calculationContext.country).value;
        const estimatedEnergyUsageNewBuilding = currentApplication.estimatedEnergyUsageNewBuilding > 0 ? currentApplication.estimatedEnergyUsageNewBuilding : currentCountry.estimatedEnergyUsageNewBuilding;
        const estimatedEnergyUsageExistingBuilding = currentApplication.estimatedEnergyUsageExistingBuilding > 0 ? currentApplication.estimatedEnergyUsageExistingBuilding : currentCountry.estimatedEnergyUsageExistingBuilding;

        calculationContext.setNewBuilding(isNewBuilding);
        calculationContext.setEnergyUsePerSquareMeter(
            isNewBuilding
                ? estimatedEnergyUsageNewBuilding
                : estimatedEnergyUsageExistingBuilding
        );
    };

    return (
        <div className='calculator__input-wrapper'>

            {/* Select New building */}
            <div className="form-item form-item--select ">
                <label htmlFor={'newBuilding'} className="form-item__label">
                    {props.translations.buildingTypeLabel}
                </label>
                <select
                    id={'newBuilding'}
                    onChange={(e) => handleBuildingTypeChange(e.target.value)} className="select__select " name="Select" >

                    <option selected={calculationContext.newBuilding === true} value={props.translations.newBuildingLabel}>{props.translations.newBuildingLabel}</option>
                    <option selected={calculationContext.newBuilding === false} value={props.translations.existingBuildingLabel}>{props.translations.existingBuildingLabel}</option>
                </select>
            </div>

            {/* Select Construction Type */}

            <div className="form-item form-item--select ">
                <div className='input-label-wrapper'>
                    <label htmlFor={props.id} className="form-item__label">
                        {props.translations.applicationLabel}
                    </label>

                </div>
                <select id={'constructionType'} onChange={e => handleApplicationChange(e.target.value)} className="select__select " name="Select" >
                    {props.applications.map((option, i) => <option key={`${i}-${option.value.application}`} selected={option.value.application === calculationContext.application} option={option.value.application}>{option.value.application}</option>)}
                </select>

            </div>

            {/* Select Energy Usage */}

            <NumberInput label={props.translations.energyUsePerSquareMeterLabel} onChange={calculationContext.setEnergyUsePerSquareMeter} value={calculationContext.energyUsePerSquareMeter} suffix={props.translations.kwhSqmLabel} />

            {/* Select Size in Square Meters */}
            <NumberInput label={props.translations.sizeInSqmLabel} onChange={calculationContext.setSizeOfBuilding} value={calculationContext.sizeOfBuilding} suffix={props.translations.squareMeter} />

        </div >
    );
};

InitialParameters.props = {
    translations: PropTypes.any,
    countries: PropTypes.any,
    applications: PropTypes.any
};

export default InitialParameters;
